var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mt-5"},[_vm._v(_vm._s(_vm.$t('Uživatelé')))]),_c('b-table',{staticClass:"mt-2",attrs:{"bordered":"","fields":_vm.dtUsers.fields,"hover":"","items":_vm.users_data,"responsive":"","small":"","stacked":"md"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }